import { render, staticRenderFns } from "./ReturnCallDialog.vue?vue&type=template&id=55b6f718&"
import script from "./ReturnCallDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnCallDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports